import { IsIn, IsOptional } from 'class-validator';

export class CompanyFilter {
  @IsOptional()
  @IsIn(['true', 'false'])
  hasDuplicates?: 'true' | 'false';

  managerId?: number;
  cityId?: number;
  year?: number;
  mediaTypeId?: number;
  okvedIds?: number[];
  tagsIds?: number[];
  endEventDate?: Date | null;
}

export class CompanyTypeFilter {
  isSupplier?: boolean;
  isClient?: boolean;
  isMedia?: boolean;
  isCompetitor?: boolean;
}
